<div class="view-header" [class.no-banner]="embedService.embed">
  <div
    class="view-header-content"
    [class.embedded]="embedService.embed"
    [class.no-initial-filters]="!jobsService.showFiltersInitial"
    >
    <div class="d-flex align-items-center mb-3" [class.mt-3]="!jobsService.showFiltersInitial">
      @if (!embedService.embed) {
        <h4 class="mb-0">
          {{
          ('jobboard.views.jobboard.title' | transloco) +
          (company
          ? ' ' + ('jobboard.views.jobboard.title-from' | transloco) + ' ' + (companyInfo$ | async)?.title
          : '')
          }}
          @if (jobsService.jobsLoading) {
            <ct-lib-spinner></ct-lib-spinner>
          }
        </h4>
      }
      @if (jobsService.showFiltersInitial) {
        <app-paginator
          class="ms-auto"
          [length]="jobsService.jobsTotal"
          (page)="jobsService.getJobs($event, company)"
        ></app-paginator>
      }
    </div>
    @if (embedService.embed && jobsService.showFiltersInitial) {
      <ct-lib-collapse-menu
        [open]="false"
        [label]="'Filter'"
        >
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </ct-lib-collapse-menu>
    }
    @if (!embedService.embed && jobsService.showFiltersInitial) {
      <div>
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
    }
    <ng-template #actions>
      <form [formGroup]="filterForm" class="actions">
        @if (jobsService.showFilter.subFilters.searchQuery) {
          <div class="row d-flex align-items-center">
            <div class="col-12 mb-3 form-floating d-flex align-items-center">
              <input
                type="text"
                class="form-control"
                [placeholder]="'jobboard.views.jobboard.filter.search-query' | transloco"
                [formControl]="filterForm.get('search')"
                id="searchQuery"
                />
              <label for="searchQuery">{{ 'jobboard.views.jobboard.filter.search-query' | transloco }}</label>
              <div class="ct-btn ct-btn-themed ms-3 filter-toggle" (click)="toggleFilter()">
                <fa-icon [icon]="fontawesomeService.regular.sliders" class="me-3"></fa-icon>
                @if (jobsService.showFilter.general) {
                  <fa-icon [icon]="fontawesomeService.regular.chevronUp"></fa-icon>
                }
                @if (!jobsService.showFilter.general) {
                  <fa-icon
                    [icon]="fontawesomeService.regular.chevronDown"
                  ></fa-icon>
                }
              </div>
            </div>
          </div>
        }
        @if (jobsService.showFilter.general) {
          <div class="row" @collapse>
            @if (jobsService.showFilter.subFilters.facilities) {
              <div class="col-12 mb-2 col-lg mb-lg-0 form-floating">
                <ng-select
                  [items]="jobsService.filterOptions.locations"
                  [multiple]="true"
                  [selectableGroup]="true"
                  [selectableGroupAsModel]="false"
                  [closeOnSelect]="false"
                  [formControl]="filterForm.get('facilities')"
                  [searchable]="true"
                  [searchFn]="facilitySearchFn"
                  id="selectedCities"
                  class="form-control tag-select"
                  bindValue="city"
                  [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  >
                  <ng-template ng-label-tmp let-item="item">
                    <ct-lib-tag class="mb-1 me-1" [accentColor]="colorService.accent">
                      {{ item.city }}
                    </ct-lib-tag>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ps-1 d-flex align-items-center">
                      <input
                        id="item-{{ index }}"
                        type="checkbox"
                        [ngModel]="item$.selected"
                        [ngModelOptions]="{standalone: true}"
                        />
                      {{ item.city }}
                    </div>
                  </ng-template>
                </ng-select>
                <label for="selectedCities">{{ 'jobboard.views.jobboard.filter.facility' | transloco }}</label>
              </div>
            }
            @if (jobsService.showFilter.subFilters.employmentTypes) {
              <div
                class="col-12 mb-2 col-lg mb-lg-0 form-floating"
                >
                <ng-select
                  [items]="jobsService.filterOptions.employmentTypes"
                  [multiple]="true"
                  [selectableGroup]="true"
                  [selectableGroupAsModel]="false"
                  [closeOnSelect]="false"
                  [formControl]="filterForm.get('employmentTypes')"
                  [searchable]="false"
                  id="selectedemploymentTypes"
                  class="form-control tag-select"
                  bindValue="value"
                  [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  >
                  <ng-template ng-label-tmp let-item="item">
                    <ct-lib-tag class="mb-1 me-1" [accentColor]="colorService.accent">
                      {{ item.label | transloco }}
                    </ct-lib-tag>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ps-1 d-flex align-items-center">
                      <input
                        id="item-{{ index }}"
                        type="checkbox"
                        [ngModel]="item$.selected"
                        [ngModelOptions]="{standalone: true}"
                        />
                      {{ item.label | transloco }}
                    </div>
                  </ng-template>
                </ng-select>
                <label for="selectedemploymentTypes">{{
                  'jobboard.views.jobboard.filter.type-of-employment' | transloco
                }}</label>
              </div>
            }
            @if (jobsService.showFilter.subFilters.workingTimes) {
              <div class="col-12 mb-2 col-lg mb-lg-0 form-floating">
                <ng-select
                  [items]="jobsService.filterOptions.workingTimes"
                  [multiple]="true"
                  [selectableGroup]="true"
                  [selectableGroupAsModel]="false"
                  [closeOnSelect]="false"
                  [formControl]="filterForm.get('workingTimes')"
                  [searchable]="false"
                  id="selectedWorkingTimes"
                  class="form-control tag-select"
                  bindValue="value"
                  [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
                  >
                  <ng-template ng-label-tmp let-item="item">
                    <ct-lib-tag class="mb-1 me-1" [accentColor]="colorService.accent">
                      {{ item.label | transloco }}
                    </ct-lib-tag>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ps-1 d-flex align-items-center">
                      <input
                        id="item-{{ index }}"
                        type="checkbox"
                        [ngModel]="item$.selected"
                        [ngModelOptions]="{standalone: true}"
                        />
                      {{ item.label | transloco }}
                    </div>
                  </ng-template>
                </ng-select>
                <label for="selectedWorkingTimes">{{ 'jobboard.views.jobboard.filter.working-time' | transloco }}</label>
              </div>
            }
          </div>
        }
      </form>
    </ng-template>
  </div>
</div>
<div class="view-content">
  <div class="jobs">
    @for (job of jobsService.jobs; track job) {
      <div class="job-wrapper">
        <a
          class="job"
          [routerLink]="['/companies', job.companyID, 'jobs', job.id]"
          [queryParams]="company ? {ref: 'company'} : null"
          [target]="embedService.embed ? '_blank' : '_self'"
          >
          <div class="info">
            <h5>{{ job.jobTitle }}</h5>
            @if (!company) {
              <p class="mb-2">{{ job.companyTitle }}</p>
            }
            <app-header-tags
              [startDate]="job.startDate"
              [employmentType]="job.employmentType"
              [workingTime]="job.workingTime"
              [locations]="job.workLocations"
              [workingModel]="job.workingModel"
              [website]="company ? null : job.website"
              [searchRegionAddress]="job.searchRegionAddress"
              [showSalaryRangeOnJobboard]="job.showSalaryRangeOnJobboard ?? false"
              [salaryCurrency]="job.currency"
              [salaryMin]="job.salaryMin"
              [salaryMax]="job.salaryMax"
              [fallbackSalary]="job.salary"
              [salaryInterval]="job.salaryInterval"
              >
            </app-header-tags>
          </div>
          <div class="icon">
            <fa-icon [icon]="fontawesomeService.regular.chevronRight"></fa-icon>
          </div>
        </a>
      </div>
    }
    @if (jobsService.jobsLoading) {
      <div class="d-flex justify-content-center">
        <ct-lib-spinner></ct-lib-spinner>
      </div>
    }
    @if (jobsService.jobs.length === 0 && !jobsService.jobsLoading) {
      <div class="no-jobs">
        <p>{{ 'jobboard.views.jobboard.list.no-results' | transloco }}</p>
      </div>
    }
  </div>
  @if (company && !(companyInfo$ | async).sandboxed) {
    <div
      class="view-section initiative"
      [class.embed]="embedService.embed"
      >
      <p>{{ 'jobboard.views.jobboard.initiative.text' | transloco }}</p>
      @if (!embedService.embed) {
        <a
          [routerLink]="['/companies', route.snapshot.params['companyId'], 'apply']"
          class="ct-btn ct-btn-themed-solid mt-2"
          >
          {{ 'jobboard.views.jobboard.initiative.button' | transloco }}
        </a>
      }
      @if (embedService.embed) {
        <a
          [routerLink]="['/companies', route.snapshot.params['companyId'], 'apply']"
          target="_blank"
          >
          {{ 'jobboard.views.jobboard.initiative.link' | transloco }}
        </a>
      }
    </div>
  }
</div>
